import { isNaniClubOidcEnabled } from "@/utils/auth/naniClubOidc";
import { naniClubUserProfileSource, oneClubUserProfileSource } from "./sources";
import type { UserProfileSource } from "./types";

export const resolveUserProfileSource = (): UserProfileSource =>
  isNaniClubOidcEnabled()
    ? naniClubUserProfileSource
    : oneClubUserProfileSource;
